import Vue from 'vue'

Vue.filter('Currency', (value, currencyCode) => {
  if (value && currencyCode) {
    return `${currencyCode} ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return '0'
})

Vue.filter('Rounded', (value, currencyCode) => {
  if (value && currencyCode) {
    return `${currencyCode} ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }
  if (value) {
    const currentvalue = Math.round(value)
    return currentvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return '-'
})



// WEBPACK FOOTER //
// ./src/filters/currency.js